import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import MdVerifiedUser from 'react-icons/lib/md/verified-user'
import OwnerView from './OwnerView'
import MdCheckCircle from 'react-icons/lib/md/check-circle'
import MdCancel from 'react-icons/lib/md/cancel'

export default class Public extends React.Component {
  static propTypes = {
    document: PropTypes.object,
    setDocumentVisibility: PropTypes.func,
    organization: PropTypes.object,
    url: PropTypes.bool,
    params: PropTypes.object
  }

  state = {}

  normalView() {
    return (
      <div className={styles.container}>
        <div className="row">
          <div className="col-xs-12 col-sm-2">
            {this.props.document.isPublic ? <MdCheckCircle size={20} /> : <MdCancel size={20} />}
          </div>
          <div className="col-xs-12 col-sm-10">Documento público</div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-2">
            {this.props.document.requireTwoFactor ? (
              <MdCheckCircle size={20} />
            ) : (
              <MdCancel size={20} />
            )}
          </div>
          <div className="col-xs-12 col-sm-10">
            Autentificación de dos factores para firmar requerida
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h3 className={styles.title}>Avanzado (Opcionales)</h3>
              </div>
              <div className="col-xs-12 col-sm-4 end-md">
                <div className={styles.icon}>
                  <MdVerifiedUser size={20} />
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            {this.props.document.documentOwner ? (
              <OwnerView document={this.props.document} organization={this.props.organization} />
            ) : (
              this.normalView()
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/AdvancedSettings/Public/index.js